export default __webpack_public_path__ + "static/media/resto.9a5b72a7.jpg";